import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=2080c9de&scoped=true&"
import script from "./NavDrawer.vue?vue&type=script&lang=js&"
export * from "./NavDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NavDrawer.vue?vue&type=style&index=0&id=2080c9de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080c9de",
  null
  
)

export default component.exports